import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  Grid,
} from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useState } from "react";
import { useEffect } from "react";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { Form, useForm } from "./useForm";
import axios from "axios";
import * as sweetalert from "sweetalert";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(4),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

export default function ConfirmDialog(props) {

  const { confirmDialog, setConfirmDialog,Banks,setBanks,setPaymentMethod,paymentMethod } = props;
  const classes = useStyles();
  useEffect(() => {}, [props.id]);
  // useEffect(() => {
  //   getAllPaymentMethods().then((res) => {
  //     setPaymentMethod(res.data);
  //   });
  //   getAllBanks().then((res) => {
  //     setBanks(res);
  //   });


  // }, []);
  // useEffect(() => {
  //   console.log('Fetching payment methods and banks');
    
  //   getAllPaymentMethods().then((res) => {
  //     console.log('Payment methods fetched:', res.data);
  //     setPaymentMethod(res.data);
  //   });

  //   getAllBanks().then((res) => {
  //     console.log('Banks fetched:', res);
  //     setBanks(res);
  //   });

  // }, []);
  const initialFValues = {
    balance: "",
    date_recharge: "",
    inventory_balance_id: props.confirmDialog.id,
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("balance" in fieldValues) {
      if (fieldValues.balance == "") {
        temp.balance = "هذا الحقل مطلوب";
      } else {
        temp.balance = "";
      }
    }

    if ("date_recharge" in fieldValues) {
      if (fieldValues.date_recharge == "") {
        temp.date_recharge = "هذا الحقل مطلوب";
      } else {
        temp.date_recharge = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };

  const { loginInput, setLogin, errors, setErrors, handleInputChange } =
    useForm(initialFValues, true, validate);
    const handleChangeDate = (newDateTime) => {
      // Convert to dayjs object
      const dayjsDateTime = dayjs(newDateTime);
      const year = dayjsDateTime.year();
      const month = dayjsDateTime.month() + 1; // Months are zero-indexed, so add 1
      const day = dayjsDateTime.date();
    
      // Format the date as needed, for example: YYYY-MM-DD
      const formattedDate = `${year}-${month < 10 ? "0" : ""}${month}-${
        day < 10 ? "0" : ""
      }${day}`;
      setLogin({ ...loginInput, date_recharge:formattedDate });

    };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const bodyFormData = new FormData();
      bodyFormData.append("inventory_balance_id", props.confirmDialog.id);
      bodyFormData.append("date_recharge", loginInput.date_recharge);
      bodyFormData.append("balance", loginInput.balance);
      axios
        .post(`${BaseUrl}/api/Recharge`, bodyFormData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            });
          } else {
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {});
          }
        });
    }
  };

  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        className={classes.dialogAction}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Form className="form-group new-design" onSubmit={handleSubmit}>
          <Grid item lg={12} md={12} xs={12}>
            <Grid item md={12} xs={12}>
              <Controls.Input
                label="قيمة الشحن"
                name="balance"
                variant="outlined"
                fullWidth
                onChange={handleInputChange}
                className="form-control"
                type="text"
                error={errors.balance}
              />
            </Grid>
            <Grid item md={12} xs={12} className="date-charge">
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                style={{ color: "#000 !important" }}
              >
                <DemoContainer
                  style={{ color: "#000 !important" }}
                  components={[
                    "DateTimePicker",
                    "DateTimePicker",
                    "DateTimePicker",
                  ]}
                >
                  <DateTimePicker
                    name="date_recharge"
                    label="تاريخ الشحن"
                    variant="outlined"
                    views={["year", "month", "day"]}
                    style={{ color: "#000 !important" }}
                    onChange={(newDateTime) => handleChangeDate(newDateTime)}
                    ampm={false}
                    value={loginInput.date_recharge}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {loginInput.date_recharge === "" ? (
                <div
                  style={{ color: "red", fontSize: "10px", textAlign: "end" }}
                >
                  {errors.date_recharge}
                </div>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} xs={12} style={{ marginTop: "15px" }}>
            <Controls.Button
              text="إلغاء"
              color="default"
              onClick={() =>
                setConfirmDialog({ ...confirmDialog, isOpen: false })
              }
            />
            <Controls.Button
              text="حفظ"
              color="secondary"
              type="submit"
              onClick={handleSubmit}
            />
          </Grid>
        </Form>
      </DialogActions>
    </Dialog>
  );
}
